import classNames from "classnames";
import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Popin from "../Popin/Popin";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import InputTextArea from "../InputTextArea/InputTextArea";
import { styles } from "./PopinQuotationActions.style";
import { Quotation } from "../../types/Quotation";
import { User } from "../../models/User.model";
import { Customer } from "../../types/Customer";
import { Document, Base64Document } from "../../types/Document";
import { getProductHelper, getTitle } from "../../helper/functions.helper";
import { CircularProgress } from "../../../node_modules/@material-ui/core";
import { theme } from "../../theme/theme";
import PrintIcon from "@material-ui/icons/Print";
import { PDFHelper } from "../../helper/PDF.helper";
import { ActionHistory } from "../../types/ActionHistory";
import * as moment from "moment";
import { PDFFormHelper } from "../../helper/PDFForm.helper";

type PopinQuotationActionsProps = {
    action: string;
    advisor: User;
    customer: Customer;
    quotation: Quotation;
    open: boolean;
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory);
    onSuccess();
    onCancel();
};

type PopinQuotationActionsState = {
    mode: "adhesion" | "proposition";
    documents: Document[];
    message: string;
    loading: boolean;
    error: boolean;
    ready: boolean;
};

class PopinQuotationActions extends React.Component<
    PopinQuotationActionsProps & WithStyles<typeof styles>,
    PopinQuotationActionsState
> {
    productHelper: any = null;
    productHelperPCO: any = null;

    state: PopinQuotationActionsState = {
        mode: "proposition",
        documents: [],
        message: "",
        loading: false,
        error: false,
        ready: false,
    };

    public async componentWillMount() {
        await this.updateState(this.props);
    }

    public async componentWillReceiveProps(nextProps: PopinQuotationActionsProps) {
        await this.updateState(nextProps);
    }

    public async updateState(props: PopinQuotationActionsProps) {
        this.productHelper = await this.initProductHelper(props, props.quotation.productVariantName);
        this.setState({
            message: this.getDefaultMessage(props, this.state.mode),
            documents: this.getRequiredDocuments(this.state.mode),
            ready: true,
        });
    }

    public async initProductHelper(props, productVariantName) {
        let productHelper = getProductHelper(props.quotation.productName, productVariantName);
        if (productHelper) {
            await productHelper.init(props.advisor, props.customer, props.quotation);
            return productHelper;
        }
        return null;
    }

    public onChangeMode(mode: "adhesion" | "proposition") {
        this.setState({
            mode: mode,
            documents: this.getRequiredDocuments(mode),
            message: this.getDefaultMessage(this.props, mode),
        });
    }

    public onSelectDocument(checkbox: any, document: Document) {
        let documents = this.state.documents;
        if (checkbox.checked) {
            documents.push(document);
        } else {
            documents = documents.filter((doc) => doc.label !== document.label);
        }
        this.setState({ documents });
    }

    public onChangeMessage(message) {
        this.setState({ message });
    }

    public async onSubmit(actionName) {
        let result: boolean = null;
        this.setState({ loading: true });
        switch (actionName) {
            case "send":
                result = await this.sendAction();
                break;
            case "download":
                result = await this.downloadAction();
                break;
            case "print":
                result = await this.printAction();
                this.onActionPerformed("print"); // TODO
                break;
            case "printPVOSouscription":
                await this.productHelper.printPVOSouscription();
                result = false;
                break;
            default:
        }
        this.setState({ loading: false });
        if (result) {
            this.onActionPerformed(actionName);
            this.props.onSuccess();
        }
    }

    public render() {
        const { classes } = this.props;

        return (
            <Popin open={this.props.open} onClick={null} maxWidth="sm" title={this.getPopinTitle()}>
                {this.renderButtons()}

                <Typography className={classes.margin}>
                    Sélectionnez les documents annexes que vous souhaitez transmettre au client (les documents
                    obligatoires seront joints automatiquement). Vous avez la possibilité de joindre un message
                    personnalisé.
                </Typography>

                <div className={classes.margin}>{this.renderDocuments()}</div>

                {this.props.action === "send" && (
                    <Grid container={true} item={true} sm={12} className={classes.margin}>
                        <InputTextArea
                            value={this.state.message}
                            onChange={(message) => this.onChangeMessage(message)}
                        />
                    </Grid>
                )}

                {this.state.ready && (
                    <Grid container={true} item={true} sm={12} justify="center" className={classes.margin}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => {
                                this.onSubmit(this.props.action);
                            }}
                        >
                            {this.props.action === "send" && "Envoyer les documents"}
                            {this.props.action === "download" && "Télécharger les documents"}
                            {this.props.action === "print" &&
                                "Imprimer" + (this.state.mode === "adhesion" ? " l'Adhésion" : " la Proposition")}
                        </Button>

                        {this.state.mode === "adhesion" &&
                        this.props.quotation.productName === "GO" &&
                        this.props.quotation.productVariantName === "PVO" &&
                        this.props.action === "print" ? (
                            <Button
                                style={{ marginLeft: theme.spacing.unit }}
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={() => {
                                    this.onSubmit("printPVOSouscription");
                                }}
                            >
                                Imprimer la souscription
                            </Button>
                        ) : null}

                        {this.state.loading && <CircularProgress size={25} className={classes.loading} />}
                        <Button
                            style={{ marginLeft: theme.spacing.unit }}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="large"
                            onClick={this.props.onCancel}
                        >
                            {this.props.action === "print" ? "Fermer" : "Annuler"}
                        </Button>
                    </Grid>
                )}
            </Popin>
        );
    }

    private renderButtons() {
        const { classes } = this.props;
        return (
            <Grid container={true} className={classes.buttons}>
                <Button
                    size="large"
                    className={classNames(classes.button, {
                        [classes.buttonActive]: this.state.mode === "proposition",
                    })}
                    onClick={() => this.onChangeMode("proposition")}
                >
                    <span>Proposition</span>
                </Button>
                <Button
                    size="large"
                    className={classNames(classes.button, {
                        [classes.buttonActive]: this.state.mode === "adhesion",
                    })}
                    onClick={() => this.onChangeMode("adhesion")}
                >
                    <span>Adhésion</span>
                </Button>
            </Grid>
        );
    }

    private renderDocuments() {
        return (
            <>
                <div>
                    {this.getRequiredDocuments(this.state.mode).map((document, index) =>
                        this.renderDocument(document, index, false)
                    )}
                    {this.getFormPDFs().map((formPDF, index) => this.renderFormPDF(formPDF, index))}
                </div>
                <div>
                    {this.getOtherDocuments(this.state.mode).map((document, index) =>
                        this.renderDocument(document, index, true)
                    )}
                </div>
            </>
        );
    }

    private renderDocument(document, index, active) {
        const isChecked = !!this.state.documents.find((d) => d.label === document.label);
        return this.props.action === "print" ? (
            <div key={index}>
                <Button
                    size="small"
                    onClick={() => this.printDocumentAction(document)}
                    className={this.props.classes.printButton}
                >
                    <PrintIcon className={this.props.classes.printIcons} />
                    {document.label}
                </Button>
            </div>
        ) : (
            <FormControlLabel
                key={index}
                control={
                    <Checkbox
                        disabled={!active}
                        checked={isChecked}
                        onChange={(e) => (active ? this.onSelectDocument(e.target, document) : null)}
                        color="primary"
                    />
                }
                label={document.label}
            />
        );
    }

    private renderFormPDF(formPDF: PDFFormHelper, index: number) {
        return this.props.action === "print" ? (
            <div key={index}>
                <Button size="small" onClick={() => formPDF.print()} className={this.props.classes.printButton}>
                    <PrintIcon className={this.props.classes.printIcons} />
                    {formPDF.getLabel()}
                </Button>
            </div>
        ) : (
            <FormControlLabel
                key={index}
                control={<Checkbox disabled={true} checked={true} color="primary" />}
                label={formPDF.getLabel()}
            />
        );
    }

    private getFormPDFs() {
        if (this.productHelper) {
            return this.state.mode === "adhesion"
                ? this.productHelper.getAdhesionFormPDFs()
                : this.productHelper.getPropositionFormPDFs();
        }
        return [];
    }

    private getRequiredDocuments(mode) {
        if (this.productHelper) {
            return this.getDocuments(mode).filter((d) => d.required);
        }
        return [];
    }

    private getOtherDocuments(mode) {
        if (this.productHelper) {
            return this.getDocuments(mode).filter((d) => !d.required);
        }
        return [];
    }

    private getDocuments(mode) {
        return mode === "adhesion"
            ? this.productHelper.getAdhesionDocuments()
            : this.productHelper.getPropositionDocuments();
    }

    // TODO: put in dico ?
    private getDefaultMessage(props: PopinQuotationActionsProps, mode) {
        return `${getTitle(props.customer.title)} ${props.customer.firstname} ${props.customer.lastname},

Suite à votre demande d’information, j’ai le plaisir de vous adresser votre ${
            mode === "adhesion" ? "adhésion" : "proposition"
        } ainsi que les documents annexes au contrat.

Je reste à votre entière disposition, ${getTitle(
            props.customer.title
        )}, et je vous prie de croire en l’assurance de mes salutations distinguées.

Votre conseiller ${props.advisor.firstname} ${props.advisor.lastname}
${props.advisor.phone ? `Tél: ${props.advisor.phone}` : ""}
${props.advisor.email ? `Email: ${props.advisor.email}` : ""}
`;
    }

    private async sendAction() {
        const subject = `Demande ${this.state.mode === "adhesion" ? "d’adhésion" : "de proposition d’adhésion"} - ${
            this.props.customer.firstname
        }  ${this.props.customer.lastname}  - ${this.productHelper.getDico().cover.title}`;

        let result = null;

        const base64documents: Base64Document[] = [];
        if (this.state.mode === "adhesion") {
            const courrierBase64document = await this.productHelper.getCourrierAdhesionBase64Document();
            if (courrierBase64document !== null) base64documents.push(courrierBase64document);

            if (this.props.quotation.productName === "GO" && this.props.quotation.productVariantName === "PVO") {
                const base64document = await this.productHelper.getPVOSouscriptionBase64Document(this.state.documents);
                base64documents.push(base64document);
            }
            result = await this.productHelper.sendAdhesionPDF(
                subject,
                this.nl2br(this.state.message),
                base64documents,
                this.state.documents
            );
        } else {
            const courrierBase64document = await this.productHelper.getCourrierPropositionBase64Document();
            if (courrierBase64document !== null) base64documents.push(courrierBase64document);

            result = await this.productHelper.sendPropositionPDF(
                subject,
                this.nl2br(this.state.message),
                base64documents,
                this.state.documents
            );
        }

        return !result.error;
    }

    private async downloadAction() {
        if (this.state.mode === "adhesion") {
            await this.productHelper.downloadAdhesionPDF(this.state.documents);
            await this.productHelper.downloadCourrierAdhesionPDF();
            if (this.props.quotation.productName === "GO" && this.props.quotation.productVariantName === "PVO") {
                await this.productHelper.downloadPVOSouscriptionPDF(this.state.documents);
            }
        } else {
            await this.productHelper.downloadPropositionPDF(this.state.documents);
            await this.productHelper.downloadCourrierPropositionPDF();
        }
        return true;
    }

    private async printAction() {
        if (this.state.mode === "adhesion") {
            await this.productHelper.printAdhesionPDF();
        } else {
            await this.productHelper.printPropositionPDF();
        }
        return false;
    }

    private async printDocumentAction(document) {
        const helper = new PDFHelper();
        helper.print(document.url);
        return true;
    }

    private getPopinTitle() {
        switch (this.props.action) {
            case "send":
                return "Envoyer les documents";
            case "print":
                return "Imprimer les documents";
            case "download":
                return "Télécharger les documents";
            default:
                return "";
        }
    }

    private onActionPerformed(action) {
        this.props.onActionPerformed(this.props.quotation, {
            date: moment().toISOString(),
            action: action,
            type: this.state.mode,
            documents: this.state.documents,
        });
    }

    private nl2br(str: string) {
        return str.replace(/\n/g, "<br />");
    }
}

export default withStyles(styles)(PopinQuotationActions);

/*
Suite à votre demande d’information, j’ai le plaisir de vous adresser votre ${this.state.mode === "adhesion" ? "proposition d’adhésion" : "adhésion"} ainsi que les documents annexes au contrat.

Pour confirmer votre adhésion, c’est très simple, il vous suffit de nous retourner l’ensemble des documents :
    - Le bulletin d’adhésion daté et signé,
    - Le mandat de prélèvement daté et signé,
    - Un relevé d’identité bancaire ou postal,
    - La photocopie recto/verso de votre pièce d’identité en cours de validité,
    ${props.quotation.productName === "GO" ? "- Un justificatif de domicile de -3 mois (facture d’électricité, gaz, téléphone, avis d’imposition…)" : ""}
A réception de votre dossier complet, nous vous adresserons votre certificat d’adhésion.

Je reste à votre entière disposition, ${getTitle(props.customer.title)}, et je vous prie de croire en l’assurance de mes salutations distinguées.

Votre conseiller ${props.advisor.firstname} ${props.advisor.lastname}`;
${props.advisor.phone ? `Tél: ${props.advisor.phone}` : "" }
*/



// WEBPACK FOOTER //
// ./src/components/PopinQuotationActions/PopinQuotationActions.tsx